import * as React from 'react';
import { compose, pure } from 'recompose';
import DayPicker from 'react-day-picker';
import DatePickerMonthYearSelection from './DatePickerMonthYearSelection';
const DatePicker = (props) => {
    const { currentDate, locale, month, onSelectDate, onSelectEnd, t, testId = 'DatePicker', withMonthYearSelection, ...other } = props;
    let firstDayOfWeek = parseInt(t('dates:firstDay'), 10);
    if (Number.isNaN(firstDayOfWeek)) {
        firstDayOfWeek = 0;
    }
    const [stateMonth, setMonth] = React.useState(month);
    React.useEffect(() => {
        if (month !== undefined) {
            setMonth(month);
        }
    }, [month]);
    const handleDayClick = React.useCallback((date, modifiers) => {
        if (modifiers) {
            const { disabled } = modifiers;
            if (disabled) {
                return;
            }
        }
        onSelectDate(date);
        onSelectEnd();
    }, [onSelectDate, onSelectEnd]);
    return (React.createElement(DayPicker, Object.assign({ captionElement: withMonthYearSelection
            ? ({ classNames, date }) => {
                return React.createElement(DatePickerMonthYearSelection, { classNames: classNames, date: date, onChange: setMonth, t: t });
            }
            : undefined, firstDayOfWeek: firstDayOfWeek, "data-testid": `${testId}`, initialMonth: currentDate, locale: locale, month: stateMonth || undefined, months: t('dates:months'), onDayClick: handleDayClick, selectedDays: currentDate, weekdaysLong: t('dates:weekdaysLong'), weekdaysShort: t('dates:weekdaysShort') }, other)));
};
const ComposedDatePicker = compose(pure)(DatePicker);
ComposedDatePicker.displayName = 'DatePicker';
export default ComposedDatePicker;
//# sourceMappingURL=DatePicker.js.map